<template>
    <div>
        <v-toolbar 
            id="eltool" 
            :collapse="!mactivo" 
            style="z-index: 1; position:relative" 
            class="hidden-sm-and-down" 
            elevation="2" 
            height="40px" 
            color="#f5f5f5"
        >
            <v-btn 
                v-if="!mactivo" 
                class="mr-3" 
                icon 
                @click="$store.commit('setPanelDesp', !mactivo)"
            >
                <v-icon color="primary"> 
                    mdi-chevron-left
                </v-icon>
            </v-btn>

            <v-btn 
                v-if="mactivo" 
                class="mr-3" 
                icon 
                @click="$store.commit('setPanelDesp', !mactivo)"
            >
                <v-icon color="primary">
                    mdi-chevron-right
                </v-icon>
            </v-btn>

            <v-divider vertical />

            <v-toolbar-title style="pading-top:5!important">
                <v-btn 
                    v-for="(x,i) in menuDespegable" 
                    :key="i" 
                    class="pr-0" 
                    color="primary" 
                    text 
                    @click="cambiaPanel(i)"
                >
                    <v-icon color="primary">
                        {{ x.icon }}
                    </v-icon>
                    <h3 class="subtitle-2 ma-2">
                        {{ x.nombre }}
                    </h3>
                </v-btn>
            </v-toolbar-title>
        </v-toolbar>

        <div class="hidden-md-and-up">
            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn 
                        class="mb-3" 
                        fab 
                        small 
                        elevation="0"
                        v-on="on" 
                    >
                        <v-icon color="primary"> 
                            mdi-chevron-down
                        </v-icon>
                    </v-btn>
                </template>
                <v-list 
                    dense 
                    color="#f5f5f5"
                >
                    <div 
                        v-for="(x, i) in menuDespegable" 
                        :key="i"
                    >
                        <v-list-item>
                            <v-icon color="primary">
                                {{ x.icon }}
                            </v-icon>
                            <v-btn 
                                color="primary" 
                                text
                                @click="cambiaPanel(i)" 
                            >
                                {{ x.nombre }}
                            </v-btn>
                        </v-list-item>
                    </div>
                </v-list>
            </v-menu>
        </div>

        <!-- <h1>Panel Seleccionado {{panelSel}}</h1> -->
    </div>
</template>


<script>
import {
    mapGetters,
    mapActions,
    mapState
} from 'vuex'

export default {
    components: {
    },
    data () {
        return {
            menuIzMin: true,
            drawerRight: true,
            drawer: true,
            ventana: 1,
            comentarios: false,
            left: false,
            right: false
        }
    },
    computed: {
        ...mapState(['menuDespegable', 'mactivo', 'menuDesp', 'msize']),
    },
    watch: {
        access_token: {
            handler (newValue, oldValue) {},
            immediate: true
        }
    },
    mounted () {
    },
    methods: {
        cambiaPanel (x) {
            this.$store.commit('setPanel', x);
        },
        ...mapActions({
            signOutOidc: 'oidc/signOutOidc',
        }),
        closeSidebar () {
            this.left = !this.left
        }

    }
}
</script>

<style scoped>

#eltool {
    border-radius: 0px 0px 0px 15px;
    -moz-border-radius: 0px 0px 0px 15px;
    -webkit-border-radius: 0px 0px 0px 15px;
    border: 0px solid #000000;
}

.v-toolbar__content {
    padding-left: 9px !important;
    padding-right: 9px !important;
}

.theme--light.v-navigation-drawer:not(.v-navigation-drawer--floating) .v-navigation-drawer__border {
    background-color: transparent !important;
}

</style>
